export type PaginationItem = number | "ellipsis";

const MAX_VISIBLE_PAGES = 7;
const PAGE_RANGE = 2;
const EARLY_PAGE_THRESHOLD = 3;

/**
 * Builds the list of page numbers (with "ellipsis" gaps) to render for a
 * paginator. Keeps the first and last page visible and a window around the
 * current page, collapsing the rest into ellipses once the total exceeds
 * MAX_VISIBLE_PAGES.
 */
export function calculateVisiblePages(
  currentPage: number,
  totalPages: number
): PaginationItem[] {
  if (totalPages <= MAX_VISIBLE_PAGES) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  const pages: PaginationItem[] = [1];

  if (currentPage <= EARLY_PAGE_THRESHOLD) {
    // Show: 1, 2, 3, 4, 5, ..., last
    for (let i = 2; i <= 5; i++) {
      pages.push(i);
    }
    pages.push("ellipsis", totalPages);
  } else if (currentPage >= totalPages - 2) {
    // Show: 1, ..., last-4, last-3, last-2, last-1, last
    pages.push("ellipsis");
    for (let i = totalPages - 4; i <= totalPages; i++) {
      pages.push(i);
    }
  } else {
    // Show: 1, ..., current-2, current-1, current, current+1, current+2, ..., last
    pages.push("ellipsis");
    for (let i = currentPage - PAGE_RANGE; i <= currentPage + PAGE_RANGE; i++) {
      pages.push(i);
    }
    pages.push("ellipsis", totalPages);
  }

  return pages;
}
